import { useEffect, useState } from 'react';
// 组件
import { ProTabs, ProSpin, } from '../antd';
import PasswordLogin from './subpage/passwordLogin';
// 方法
import { useNavigate } from 'react-router-dom';
import { user_securityInfo_api } from '../api/user';
// 常量
import { SUCCESS_STATUS_CODE } from '../constants/constant';
import { TabItems } from './config';
import './style.less';
import { USER_NAME_KEY } from '../constants/localStorage';

const Login = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [publicKey, setPublicKey] = useState<string>();
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    user_securityInfo_api().then(res => {
      if (res.code === SUCCESS_STATUS_CODE) {
        const data = res.data;
        setPublicKey(data?.publicKey);
      }
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  const handleLoginSuccess = async (data: any) => {
    setLoading(true);
    window.localStorage.setItem(USER_NAME_KEY, data?.userName);
    navigate('/');
  };
  return (
    <div className='yb-wrapper'>
      <div className='yb-wrapper-login'>
        <div className='login-wrapper'>
          <ProTabs items={TabItems} />
          <ProSpin spinning={loading}>
            <PasswordLogin publicKey={publicKey} onSuccess={handleLoginSuccess} />
          </ProSpin>
        </div>
      </div>
      <div className='yb-wrapper-info'>
        <span>版权所有 ©2020-2021</span>
        <a className='record-number' target='_blank' href='https://beian.miit.gov.cn/'>闽ICP备2021007909号</a>
      </div>
    </div>
  );
};

export default Login;